module.exports = __webpack_public_path__ + "static/media/Oak+Fort-logo-thin-black.effdb8cb.svg";